import React, { FC, useEffect, useRef, useState } from "react";
import { Element } from "../../../../models/elementModel";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getTabListbyElementId,
  getTabPanelByTab,
  getTabsByElementId,
} from "../../../../selectors/tabListSelector";
import { getAllRows } from "../../../../selectors/rowListSelector";
import RowElement from "../../RowElement";
import { useDrop } from "react-dnd";
import { ItemTypes } from "../../../../utils/itemTypes";
import TabPanelContent from "./tabPanel";
import { TabModel } from "../../../../models/tabModel";
import { TabGroupModel } from "../../../../models/tabGroupModel";
import ActionListComponent from "../../../utilComponents/actionListComponent/actionListComponent";
import { NavDropdownMenu } from "react-bootstrap-submenu";
import { NavDropdown } from "react-bootstrap";
import { getSession } from "../../../../selectors/appSelectors";
import { Tooltip } from "react-tippy";

export interface TabProps {
  index: string;
  element: Element;
  isPreview?: boolean;
}

const TabElement: FC<TabProps> = ({ index, element, isPreview = false }) => {
  const sessionState = useSelector(getSession);
  const [viewRemark, setViewRemark] = useState(sessionState.viewRemark);
  const tabList = useSelector(getTabsByElementId(element.id));
  const test = useSelector(getTabListbyElementId(element.id, isPreview));
  const [selectedDropDownTabIndex, setSelectedDropDownTabIndex] = useState(0);
  const [open, setIsOpen] = useState(false);

  useEffect(() => {
    setViewRemark(sessionState.viewRemark)
    console.log(sessionState.viewRemark)

  }, [sessionState])

  const renderDropDownTabs = (tabs: TabModel[], index: number) => {
    return (
      <Tab>
        <NavDropdownMenu className={`${tabs[0].display === false ? "blur-element" : ""}`}
          title={tabs[0].tabGroupTitle}
          id={`${tabs[0].id}-main`}
        >
          {tabs.map((tab, i) => {
            return (
              <div
                onClick={() => {
                  setSelectedDropDownTabIndex(i);
                }}
              >
                <NavDropdown.Item id={tab.id}>{tab.name}</NavDropdown.Item>
              </div>
            );
          })}
        </NavDropdownMenu>
      </Tab>
    );
  };

  const renderTabs = () => {
    return test.map((tab, i) => {
      if (tab.tabList.length > 0) {
        if (!tab.tabList[0].isDropDownTab) {
          return <Tab className={`react-tabs__tab ${tab.tabList[0].display === false ? "blur-element" : ""}`}>{tab.tabList[0].name}</Tab>;
        } else {
          return renderDropDownTabs(tab.tabList, i);
        }
      }
    });
  };

  const renderTabPanelContent = (tab: TabGroupModel, index: number) => {
    if (!tab.tabList[0].isDropDownTab) {
      return (
        <TabPanelContent
          index={index}
          tab={tab.tabList[0]}
          isPreview={isPreview}
        />
      );
    } else {
      if (selectedDropDownTabIndex >= tab.tabList.length) {
        return (
          <TabPanelContent
            index={index}
            tab={tab.tabList[0]}
            isPreview={isPreview}
          />
        );
      } else {
        return (
          <TabPanelContent
            index={index}
            tab={tab.tabList[selectedDropDownTabIndex]}
            isPreview={isPreview}
          />
        );
      }
    }
  };

  const renderTabPanels = () => {
    return test.map((tab, i) => {
      if (tab.tabList.length > 0) return <TabPanel>{renderTabPanelContent(tab, i)}</TabPanel>;
    });
  };

  const defaultStyle = {
    marginTop: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginTop + "px",
    marginRight: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginRight + "px",
    marginBottom: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginBottom + "px",
    marginLeft: element.properties.isMarginAll
      ? element.styles.margin + "px"
      : element.styles.marginLeft + "px",
    textAlign: element.styles.textAlign,
  };
  //custome css - start
  const styleList = element.properties.cssStyles;

  const styleObj: { [key: string]: any } = {};

  for (let index = 0; index < styleList.length; index++) {
    styleObj[styleList[index].retrivedStyle] = styleList[index].value;
  }
  //custome css - end
  return (
    <>
      <Tabs
        key={index}
        className={`${
          element.properties.display === false ? "blur-element" : ""
        }`}
        style={{ ...defaultStyle, ...styleObj }}
      >
        <TabList>{renderTabs()}</TabList>
        {renderTabPanels()}
      </Tabs>
      {isPreview &&
        viewRemark &&
        (element.properties.remark1 ||
          element.properties.remark2 ||
          element.properties.remark3 ||
          element.properties.remark4) && (
          <Tooltip
            interactive
            open={open}
            onRequestClose={() => setIsOpen(false)}
            html={
              <>
                <h6>Remarks of {element.name}</h6>
                {element.properties.remark1 !== undefined &&
                  element.properties.remark1 !== "" && (
                    <div>Remark 1 : {element.properties.remark1}</div>
                  )}
                {element.properties.remark2 !== undefined &&
                  element.properties.remark2 !== "" && (
                    <div>Remark 2 : {element.properties.remark2}</div>
                  )}
                {element.properties.remark3 !== undefined &&
                  element.properties.remark3 !== "" && (
                    <div>Remark 3 : {element.properties.remark3}</div>
                  )}
                {element.properties.remark4 !== undefined &&
                  element.properties.remark4 !== "" && (
                    <div>Remark 4 : {element.properties.remark4}</div>
                  )}
                {(element.properties.remark1 === undefined ||
                  element.properties.remark1 === "") &&
                  (element.properties.remark2 === undefined ||
                    element.properties.remark2 === "") &&
                  (element.properties.remark3 === undefined ||
                    element.properties.remark3 === "") &&
                  (element.properties.remark4 === undefined ||
                    element.properties.remark4 === "") && (
                    <div>No Remarks to Display</div>
                  )}
              </>
            }
            position="left"
          >
            <div style={{ textAlign: "end" }}>
              <i
                className="fa fa-info-circle"
                aria-hidden="true"
                onClick={() => {
                  setIsOpen(true);
                }}
              ></i>
            </div>
          </Tooltip>
        )}
    </>
  );
};

export default TabElement;
